import { all, call, put, takeEvery, fork } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
    getNotificationsSuccess,
    getNotificationsFailure,
    getNotificationsNumberSuccess,
    getNotificationsNumberFailure,
} from './actions';
import {
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_NUMBER,
} from './constants';
const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

// Get Notifications
function* getNotificationsSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/User/notifications`, options);
        // Extract only notification objects, ignore 'status'
        const notifications = Object.keys(response)
            .filter(key => key !== 'status')
            .map(key => response[key]);
        yield put(getNotificationsSuccess(notifications.length ? notifications : []));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = error.description || 'An error occurred';
        }
        yield put(getNotificationsFailure(message));
    }
};

// Get Notifications Count
function* getNotificationsCountSaga() {
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    try {
        const response = yield call(fetchJSON, `${SERVER_URL}/User/notifynum`, options);
        yield put(getNotificationsNumberSuccess(response.count));
    } catch (error) {
        let message;
        if (error.statusCode) {
            const errorDesc = (error.error && error.error.description) ? error.error.description : null;
            switch (error.statusCode) {
                case 500:
                    message = 'Internal Server Error';
                    break;
                case 401:
                    message = errorDesc || 'Invalid credentials UNAUTHENTICATED';
                    break;
                default:
                    message = errorDesc || 'An error occurred';
            }
        } else {
            message = error.description || 'An error occurred';
        }
        yield put(getNotificationsNumberFailure(message));
    }
};

// Watcher Saga
export function* watchGetNotificationsSaga() {
    yield takeEvery(GET_NOTIFICATIONS, getNotificationsSaga);
}

export function* watchGetNotificationsCountSaga() {
    yield takeEvery(GET_NOTIFICATIONS_NUMBER, getNotificationsCountSaga);
}
// Root Saga
export default function* notificationsSaga() {
    yield all([
        fork(watchGetNotificationsSaga),
        fork(watchGetNotificationsCountSaga),
    ]);
}